/**
 * AUTO-GENERATED — do not edit manually.
 * Run: npm run generate:permissions
 * 
 * This file is generated from backend/src/Security/Permission/PermissionCode.php
 */

export const PERMISSIONS = {
  CREATION: {
    EMPLOYES: {
      VIEW: 'creation.employes.view',
    },
    ARTICLES: {
      VIEW: 'creation.articles.view',
      CREATE: 'creation.articles.create',
      EDIT: 'creation.articles.edit',
      DELETE: 'creation.articles.delete',
      ARCHIVE: 'creation.articles.archive',
      EXPORT: 'creation.articles.export',
      IMPORT: 'creation.articles.import',
    },
    DOCUMENTS: {
      VIEW: 'creation.documents.view',
      CREATE: 'creation.documents.create',
      EDIT: 'creation.documents.edit',
      DELETE: 'creation.documents.delete',
      DOWNLOAD: 'creation.documents.download',
      UPLOAD: 'creation.documents.upload',
      EXPORT: 'creation.documents.export',
    },
    ATELIERS: {
      VIEW: 'creation.ateliers.view',
      CREATE: 'creation.ateliers.create',
      EDIT: 'creation.ateliers.edit',
      DELETE: 'creation.ateliers.delete',
    },
    POSTES: {
      VIEW: 'creation.postes.view',
      CREATE: 'creation.postes.create',
      EDIT: 'creation.postes.edit',
      DELETE: 'creation.postes.delete',
      EXPORT: 'creation.postes.export',
    },
    PRESTATIONS: {
      VIEW: 'creation.prestations.view',
      CREATE: 'creation.prestations.create',
      EDIT: 'creation.prestations.edit',
      DELETE: 'creation.prestations.delete',
    },
    DOSSIER_TECHNIQUES: {
      VIEW: 'creation.dossier_techniques.view',
      CREATE: 'creation.dossier_techniques.create',
      EDIT: 'creation.dossier_techniques.edit',
      DELETE: 'creation.dossier_techniques.delete',
    },
    FAMILLE_ARTICLES: {
      VIEW: 'creation.familleArticles.view',
      CREATE: 'creation.familleArticles.create',
      EDIT: 'creation.familleArticles.edit',
      DELETE: 'creation.familleArticles.delete',
    },
    UNIVERS_COMMERCIAUX: {
      VIEW: 'creation.universCommerciaux.view',
      CREATE: 'creation.universCommerciaux.create',
      EDIT: 'creation.universCommerciaux.edit',
      DELETE: 'creation.universCommerciaux.delete',
    },
    LDF: {
      VIEW: 'creation.ldf.view',
      CREATE: 'creation.ldf.create',
      EDIT: 'creation.ldf.edit',
      DELETE: 'creation.ldf.delete',
    },
  },
  RH: {
    CONGES: {
      VIEW: 'rh.conges.view',
      CREATE: 'rh.conges.create',
      EDIT: 'rh.conges.edit',
      DELETE: 'rh.conges.delete',
      VALIDATE: 'rh.conges.validate',
    },
    POINTAGE: {
      VIEW: 'rh.pointage.view',
      CREATE: 'rh.pointage.create',
      EDIT: 'rh.pointage.edit',
      VALIDATE: 'rh.pointage.validate',
    },
    PLANIFICATION: {
      VIEW: 'rh.planification.view',
      CREATE: 'rh.planification.create',
      EDIT: 'rh.planification.edit',
      VALIDATE: 'rh.planification.validate',
    },
    FEUILLES_DE_TEMPS: {
      VIEW: 'rh.feuilles_de_temps.view',
      CREATE: 'rh.feuilles_de_temps.create',
      EDIT: 'rh.feuilles_de_temps.edit',
      VALIDATE: 'rh.feuilles_de_temps.validate',
    },
    DOCUMENTS: {
      VIEW: 'rh.documents.view',
      CREATE: 'rh.documents.create',
      EDIT: 'rh.documents.edit',
      DELETE: 'rh.documents.delete',
      DOWNLOAD: 'rh.documents.download',
      UPLOAD: 'rh.documents.upload',
    },
    CONTRATS: {
      VIEW: 'rh.contrats.view',
      CREATE: 'rh.contrats.create',
      EDIT: 'rh.contrats.edit',
    },
    EMPLOYES: {
      VIEW: 'rh.employes.view',
      CREATE: 'rh.employes.create',
      EDIT: 'rh.employes.edit',
    },
    FRAIS: {
      VIEW: 'rh.frais.view',
      CREATE: 'rh.frais.create',
      EDIT: 'rh.frais.edit',
    },
  },
  SECURITY: {
    USERS: {
      VIEW: 'security.users.view',
      CREATE: 'security.users.create',
      EDIT: 'security.users.edit',
      DELETE: 'security.users.delete',
    },
    PROFILES: {
      VIEW: 'security.profiles.view',
      CREATE: 'security.profiles.create',
      EDIT: 'security.profiles.edit',
      DELETE: 'security.profiles.delete',
    },
    PERMISSIONS: {
      VIEW: 'security.permissions.view',
      EDIT: 'security.permissions.edit',
    },
  },
  PRODUCTION: {
    DASHBOARD: {
      VIEW: 'production.dashboard.view',
    },
  },
  COMMERCE: {
    DASHBOARD: {
      VIEW: 'commerce.dashboard.view',
    },
  },
  FACTURATION: {
    DASHBOARD: {
      VIEW: 'facturation.dashboard.view',
    },
  },
  LOGISTIQUE: {
    DASHBOARD: {
      VIEW: 'logistique.dashboard.view',
    },
  },
  STOCK: {
    DASHBOARD: {
      VIEW: 'stock.dashboard.view',
    },
    DEPOTS: {
      VIEW: 'stock.depots.view',
      CREATE: 'stock.depots.create',
      EDIT: 'stock.depots.edit',
      DELETE: 'stock.depots.delete',
    },
    EMPLACEMENTS: {
      VIEW: 'stock.emplacements.view',
      CREATE: 'stock.emplacements.create',
      EDIT: 'stock.emplacements.edit',
      DELETE: 'stock.emplacements.delete',
    },
    MOVEMENTS: {
      VIEW: 'stock.movements.view',
      CREATE: 'stock.movements.create',
    },
    INVENTAIRES: {
      VIEW: 'stock.inventaires.view',
      CREATE: 'stock.inventaires.create',
      EDIT: 'stock.inventaires.edit',
    },
    CONSULTATION: {
      VIEW: 'stock.consultation.view',
    },
  },
  QUALITE: {
    DASHBOARD: {
      VIEW: 'qualite.dashboard.view',
    },
  },
  FINANCE: {
    DASHBOARD: {
      VIEW: 'finance.dashboard.view',
    },
  },
  DOCUMENTS: {
    DOCUMENTS: {
      VIEW: 'documents.view',
      CREATE: 'documents.create',
      EDIT: 'documents.edit',
      DELETE: 'documents.delete',
    },
  },
  SETTINGS: {
    USER: {
      VIEW: 'settings.user.view',
      EDIT: 'settings.user.edit',
    },
  },
  STOCK: {
    STOCK: {
      VIEW: 'stock.view',
      CREATE: 'stock.create',
      EDIT: 'stock.edit',
      DELETE: 'stock.delete',
    },
  },
  ACHATS: {
    FOURNISSEURS: {
      VIEW: 'achats.fournisseurs.view',
      CREATE: 'achats.fournisseurs.create',
      EDIT: 'achats.fournisseurs.edit',
      DELETE: 'achats.fournisseurs.delete',
      EXPORT: 'achats.fournisseurs.export',
      IMPORT: 'achats.fournisseurs.import',
    },
    FOURNITURES: {
      VIEW: 'achats.fournitures.view',
      CREATE: 'achats.fournitures.create',
      EDIT: 'achats.fournitures.edit',
      DELETE: 'achats.fournitures.delete',
    },
    COMMANDES: {
      VIEW: 'achats.commandes.view',
      CREATE: 'achats.commandes.create',
      EDIT: 'achats.commandes.edit',
      DELETE: 'achats.commandes.delete',
      VALIDATE: 'achats.commandes.validate',
    },
    RECEPTIONS: {
      VIEW: 'achats.receptions.view',
      CREATE: 'achats.receptions.create',
      EDIT: 'achats.receptions.edit',
      DELETE: 'achats.receptions.delete',
    },
    FACTURES: {
      VIEW: 'achats.factures.view',
      CREATE: 'achats.factures.create',
      EDIT: 'achats.factures.edit',
      DELETE: 'achats.factures.delete',
      PAY: 'achats.factures.pay',
    },
  },
} as const

/**
 * Union type of all permission strings
 */
// Manual union for now - could be generated more precisely
export type PermissionString = string
